import { FC, PropsWithChildren } from 'react';

export const Title: FC<PropsWithChildren> = ({ children }) => (
  <h3 className={'text-barbie mb-2.5 text-lg font-light sm:mb-4'}>{children}</h3>
);
